import { Injectable } from '@angular/core';
import { ProcallConnectivityStep } from '../../models/app/precall/precall-connectivity-step';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class ConnectivityStore extends BaseStore<ProcallConnectivityStep> {}
